<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description:
-->
<template>
  <div id="app">
    <keep-alive include="NutritionTools">
      <keep-alive :include="cachedViews">
        <router-view />
      </keep-alive>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cachedViews: ['ClinicIndex', 'ListStyle'],
    }
  },
  watch: {
    // 监听路由变化，动态添加/移除缓存
    '$route' (to, from) {
      // console.log('路由变化', to, from,from.name==='listStyle'&&from.query.id)
      if(to.name==='clinicIndex'){
        if(from.name==='listStyle'&&to.query.clearCache){
           this.cachedViews=[]
        }else{
          this.cachedViews.push('ClinicIndex','ListStyle')
         
        }

      }
     
    }
  }
}
</script>

<style>
/*引入阿里字体图标*/
@import './assets/iconfont/iconfont.css';

#app {
  height: 100%;
}

/*全局样式*/
* {
  font-family: "HanHei SC", PingHei, "PingFang SC", "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei", "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei", sans-serif;
  ;
  font-style: normal;
  /*font-weight: normal;*/
}

body,
html {
  margin: 0;
  padding: 0;
  font-size: 12px;
  width: 100%;
  height: 100%;
}

p {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
  outline: none;
  font-size: 20px;
  color: #333;
}

/*ul {*/
/*  list-style: none;*/
/*}*/
</style>
